export const SET_TESTDRIVE_ID = 'SET_TESTDRIVE_ID'



// WEBPACK FOOTER //
// ./src/store/modules/testdrive/types.js